var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgVerifiedProfile = function SvgVerifiedProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2218",
    d: "M16.794 4.498l-2.089-1.2L13.5 1.206h-2.412L9-.002 6.911 1.206H4.5L3.294 3.298l-2.088 1.2v2.413L0 8.998l1.206 2.09v2.41l2.089 1.206L4.5 16.798h2.412L9 17.998l2.088-1.2H13.5l1.206-2.089 2.088-1.211v-2.41L18 8.998l-1.206-2.087V4.498zm-8.606 8.185a.876.876 0 01-1.218 0l-2.633-2.632a.845.845 0 010-1.194l.7-.7a.845.845 0 011.194 0l1.35 1.35 4.192-4.193a.845.845 0 011.194 0l.7.7a.845.845 0 010 1.194z",
    fill: "#439aff"
  })));
};
export default SvgVerifiedProfile;